export default __webpack_public_path__ + "static/media/man_typen_final_vid2.ed83704d.mp4";